<template>
  <div class="payment-select text-center">
    <box-header :title="$t('paymentselect.title')"></box-header>
    <div class="row scroll">
      <div class="col-sm-12">
        <button-method
          :method="method"
          v-for="method in pageDetails.paymentMethods"
          :key="method"
        ></button-method>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const paymentNS = createNamespacedHelpers("payment");

import boxHeader from "@/components/box-header.vue";
import buttonMethod from "@/components/button-method.vue";

const viewportWidth = Math.max(
  document.documentElement.clientWidth,
  window.innerWidth || 0
);

export default {
  name: "paymentMethodSelection",
  components: {
    boxHeader,
    buttonMethod,
  },
  mounted() {
    //select the payment method if there is just one
    if (
      this.autoSelectSinglePaymentMethod &&
      this.pageDetails.paymentMethods &&
      this.pageDetails.paymentMethods.length === 1
    ) {
      this.setAutoSelectSinglePaymentMethod(false);
      let button = document.querySelector(
        "button." + this.pageDetails.paymentMethods[0]
      );
      button.click();
    }
    this.setOverlayBox(false);
    if (viewportWidth < 576) {
      document.querySelector(".payment-info").classList.remove("small-box");
      document.querySelector(".scroll").classList.remove("small-box");
    }
  },
  computed: {
    ...paymentNS.mapGetters(["pageDetails", "autoSelectSinglePaymentMethod"]),
  },
  methods: {
    ...paymentNS.mapActions(["setOverlayBox"]),
    ...paymentNS.mapMutations(["setAutoSelectSinglePaymentMethod"]),
  },
};
</script>
